<template>
  <res-dialog :showDialog="showDialog"
              :maxWidth="maxWidth"
              :setWidth="setWidth"
              title="Are you sure?"
              titleClass="resBlue darken-1 white--text"
              :showTitleIcon="true"
              :titleIconSize="17"
              iconColor="white"
              saveButtonText="YES"
              :saveDisabled="isSaveButtonDisabled"
              cancelButtonText="CANCEL"
              cancelButtonWidth="80"
              :defaultButtonAction="confirm"
              @save="confirm"
              @cancel="cancel" >
    <v-card-text>
      <span class="font-weight-500">
        {{ description }}
      </span>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    components: {
      ResDialog
    },
    props: {
      showDialog: {
        type: Boolean
      },
      altText: null,
      maxWidth: null,
      setWidth: null
    },
    data () {
      return {
        isSaveButtonDisabled: false
      }
    },
    methods: {
      cancel() {
        this.isSaveButtonDisabled = true;
        this.$emit('cancel', true)
      },
      confirm() {
        this.isSaveButtonDisabled = true;
        this.$emit('confirm', true)
      }
    },
    computed: {
      description() {
        return this.altText || 'This will clear all data from this tab and add back any starting default numbers. Are you sure you want to do this?';
      }
    }
  }
</script>

